.container {
  text-align: center;
}

/* The icon takes the tone colour from Typography's `color`, so the SVG's currentColor is a token. */
.icon {
  display: flex;
  line-height: 0;
}

.description {
  max-width: 320px;
}

.action {
  margin-top: 8px;
  min-width: 180px;
}
